import {
  useGetUserAiAssignments,
  useDeleteAiAssignment,
  getGetUserAiAssignmentsQueryKey,
  useGetTopAiAssignments,
  likeAiAssignment,
  unlikeAiAssignment,
  getGetTopAiAssignmentsQueryKey,
} from "@packages/api/madlenAPI";
import { AiAssignmentResponseDto } from "@packages/api/madlenAPI.schemas";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import AiAssignmentCard from "../../components/ai-assignment-designer/AiAssignmentCard";

const AiAssignmentDetailComponent = ({
  tool,
}: {
  tool: AiAssignmentResponseDto;
}) => {
  return <AiAssignmentCard assignment={tool} />;
};

const AiAssignmentDesignerView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserAiAssignments}
      useDeleteTool={useDeleteAiAssignment}
      getGetToolsQueryKey={getGetUserAiAssignmentsQueryKey}
      useGetTopTools={useGetTopAiAssignments}
      likeTool={likeAiAssignment}
      unlikeTool={unlikeAiAssignment}
      getGetTopToolsQueryKey={getGetTopAiAssignmentsQueryKey}
      toolType="aiAssignmentDesigner"
      toolPath="ai-assignment-designer"
      DetailComponent={AiAssignmentDetailComponent}
      colors={{
        light: "from-amber-500 to-amber-500",
        dark: "dark:from-amber-400 dark:to-amber-400",
        iconBg: "bg-amber-100 dark:bg-amber-900/50",
        iconColor: "text-amber-600 dark:text-amber-400",
        hover: "hover:bg-indigo-50 dark:hover:bg-indigo-900/20",
      }}
      toolColor="amber"
      gradientColor="amber"
    />
  );
};

export default AiAssignmentDesignerView;
